const capitalizeWords = (str) => {
    if (str) {
        return String(str).toLowerCase().replace(/\b\w/g, function (l) {
            return l.toUpperCase();
        });
    }
};

export default capitalizeWords;
